import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllDrivers = createAsyncThunk('drivers/getAllDrivers', async (page = 1, thunkAPI) => {
  try {
    const response = await axiosInstance.get(
      `/admin/driver-accounts?limit=10&page=${page}&with_approval=true&status=approved`,
    );
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getDetailDriver = createAsyncThunk('drivers/getDetailDriver', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/driver-accounts/${id}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const createNewDriver = createAsyncThunk('drivers/createNewDriver', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/admin/driver-accounts`, { ...payload });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteDriverById = createAsyncThunk('drivers/deleteDriverById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/driver-accounts/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const switchDriverStatus = createAsyncThunk('drivers/switchDriverStatus', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/admin/driver-accounts/${id}/switch-deactivate`, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const editDriver = createAsyncThunk('drivers/editDriver', async ({ payload, id }, thunkAPI) => {
  try {
    const response = await axiosInstance.put(`/admin/driver-accounts/${id}`, { ...payload });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDriverTransactionHistory = createAsyncThunk(
  'drivers/getDriverTransactionHistory',
  async (payload, thunkAPI) => {
    const { id, limit, page } = payload;

    let newUrl = `/admin/transaction-histories/${id}/driver`;

    if (limit) {
      newUrl += `?limit=${limit}`;
    }

    if (page) {
      newUrl += `&page=${page}`;
    }

    try {
      const response = await axiosInstance.get(newUrl);

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getAllDriversByFilter = createAsyncThunk('drivers/getAllDriversByFilter', async (params, thunkAPI) => {
  const { page, limit, search, locationId, isDeactivated, packageId } = params;

  let newUrl = `/admin/driver-accounts?limit=${limit}&page=${page}&status=approved`;

  if (search) {
    newUrl += `&search=${search}`;
  }

  if (locationId) {
    newUrl += `&location_id=${locationId}`;
  }

  if (typeof isDeactivated === 'boolean') {
    newUrl += `&is_deactivated=${isDeactivated}`;
  }

  if (packageId) {
    newUrl += `&vehicle_package_id=${packageId}`;
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getAllDriverTasks = createAsyncThunk('drivers/getAllDriverTasks', async (params, thunkAPI) => {
  const { page, limit, status, orderBy } = params;

  let newUrl = `/admin/driver-tasks?page=${page}&limit=${limit}&order_seq=DESC`;

  if (status && status.length !== 0) {
    for (let statusChild of status) {
      newUrl += `&status=${statusChild}`;
    }
  }

  if (orderBy) {
    newUrl += `&order_by=${orderBy}`;
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getDetailDriverTask = createAsyncThunk('drivers/getDetailDriverTask', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/driver-tasks/${id}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const updateDriverTask = createAsyncThunk('drivers/updateDriverTask', async (payload, thunkAPI) => {
  const { id, ...payloadData } = payload;

  try {
    const response = await axiosInstance.patch(`/admin/driver-tasks/${id}`, {
      ...payloadData,
    });
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDetailVehiclePackages = createAsyncThunk(
  'drivers/getDetailVehiclePackages',
  async (packageId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/admin/vehicle-packages/${packageId}`);

      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getAllWithdraw = createAsyncThunk('drivers/getAllWithdraw', async (params, thunkAPI) => {
  const { page, limit, status, name, orderBy, orderSeq } = params;

  let newUrl = `/admin/withdraws`;

  if (page) {
    if (newUrl.includes('?')) {
      newUrl += `&page=${page}`;
    } else {
      newUrl += `?page=${page}`;
    }
  }

  if (limit) {
    if (newUrl.includes('?')) {
      newUrl += `&limit=${limit}`;
    } else {
      newUrl += `?limit=${limit}`;
    }
  }

  if (status !== undefined) {
    status.map((item) => {
      newUrl += `&status[]=${item}`;
    });
  }

  if (orderSeq) {
    newUrl += `&order_seq=${orderSeq}`;
  }

  if (orderBy) {
    newUrl += `&order_by=${orderBy}`;
  }

  if (name !== undefined) {
    newUrl += `&name=${name}`;
  }

  try {
    const response = await axiosInstance.get(newUrl);
    const data = await response.data;
    return data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getDetailWithdraw = createAsyncThunk('drivers/getDetailWithdraw', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/withdraw/${id}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getTransactionHistory = createAsyncThunk('drivers/getTransactionHistory', async (payload, thunkAPI) => {
  const { id, showType, refId, limit, page } = payload;

  let newUrl = `/admin/transaction-histories/${id}/driver`;

  if (showType) {
    if (newUrl.includes('?')) {
      newUrl += `&show_type=${showType}`;
    } else {
      newUrl += `?show_type=${showType}`;
    }
  }

  if (refId) {
    if (newUrl.includes('?')) {
      newUrl += `&ref_id=${refId}`;
    } else {
      newUrl += `?ref_id=${refId}`;
    }
  }

  if (limit) {
    if (newUrl.includes('?')) {
      newUrl += `&limit=${limit}`;
    } else {
      newUrl += `?limit=${limit}`;
    }
  }

  if (page) {
    if (newUrl.includes('?')) {
      newUrl += `&page=${page}`;
    } else {
      newUrl += `?page=${page}`;
    }
  }

  try {
    const response = await axiosInstance.get(newUrl);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const approvalWithdraw = createAsyncThunk('drivers/approvalWithdraw', async (payload, thunkAPI) => {
  const { id, status, cancelReason, image } = payload;

  let payloadData;

  if (status === 'reject') {
    payloadData = { reason: cancelReason };
  } else if (status === 'process') {
    if (image) {
      payloadData = new FormData();
      payloadData.append('file', image);
    } else {
      payloadData = undefined;
    }
  } else {
    payloadData = undefined;
  }

  try {
    const response = await axiosInstance.post(`/admin/withdraw/${id}/${status}`, payloadData);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const uploadTransferProofWithdraw = createAsyncThunk(
  'drivers/uploadTransferProofWithdraw',
  async (payload, thunkAPI) => {
    const { id, image } = payload;

    try {
      const response = await axiosInstance.post(
        `/admin/withdraw/upload`,
        { file: image, id },
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getVehiclePackages = createAsyncThunk('drivers/getVehiclePackages', async (locationId, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/vehicle-packages?limit=10&page=1&location_id=${locationId}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

// UPLOAD FILE IMAGE
export const uploadImageVehicle = createAsyncThunk('vehicle/uploadImageVehicle', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/vehicles/upload`,
      { file: payload },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data.file;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const processDriverVerification = createAsyncThunk(
  'drivers/processDriverVerification',
  async (payload, thunkAPI) => {
    const { id, data } = payload;

    try {
      const response = await axiosInstance.post(`/admin/driver-accounts/${id}/verify`, {
        ...data,
      });

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getAllNewRegisteredDrivers = createAsyncThunk(
  'drivers/getAllNewRegisteredDrivers',
  async (page, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/admin/driver-accounts?limit=10&page=${page}&status=new`);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  },
);

export const getDriverReviews = createAsyncThunk('drivers/getDriverReviews', async (payload, thunkAPI) => {
  const { page, id, limit = 10 } = payload;

  try {
    const response = await axiosInstance.get(`/drivers/${id}/reviews?limit=${limit}&page=${page}`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});

export const getDriverRating = createAsyncThunk('drivers/getDriverRating', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/drivers/${id}/reviews/ratings`);
    return response.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response.data);
  }
});
